import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const TransferBenefitsScroll = ({ slides }) => {
  const [slidesPerView, setSlidesPerView] = useState(2);

  useEffect(() => {
    const updateSlidesPerView = () => {
      setSlidesPerView(window.innerWidth <= 768 ? 1 : 2);
    };

    updateSlidesPerView();
    window.addEventListener("resize", updateSlidesPerView);
    return () => window.removeEventListener("resize", updateSlidesPerView);
  }, []);

  const slidesData = [
    {
      img: "/assets/ZeroManualProcessesImg .gif",
      title1: "Zero Manual",
      title2: "Processes ",
      description:
        "Say goodbye to paperwork! Nimo’s intuitive platform automates the entire remittance process, saving you time and effort. ",
    },
    {
      img: "/assets/One-TimeKYCImg.gif",
      title1: "One-Time",
      title2: "KYC",
      description:
        "Complete your KYC just once and enjoy seamless transactions for all your future remittance needs. ",
    },
    {
      img: "/assets/customersupport.gif",
      title1: "24/7 Customer",
      title2: "Support",
      description:
        "Need assistance? Our dedicated support team is available around the clock to help you. ",
    },
    {
      img: "/assets/RealTimeTrackking.gif",
      title1: "Real-Time",
      title2: "Tracking",
      description:
        "Monitor your money as it moves, from initiation to completion, with Nimo’s live tracking feature. ",
    },
    {
      img: "/assets/MobileBanking.gif",
      title1: "Trusted Banking",
      title2: "Partners",
      description:
        "Your money is safe with Nimo, powered by partnerships with leading, globally recognized banks. ",
    },
    {
      img: "/assets/Fastmoneytransaction.gif",
      title1: "Fast",
      title2: "Transfers",
      description:
        "Experience near-instant remittances to major destinations worldwide, ensuring your funds reach on time. ",
    },
  ];

  return (
    <div className="relative mb-4 md:mb-[5rem] mt-20">
      {/* Custom Navigation Buttons */}
      <button className="custom-prev group absolute md:right-[5%] left-[2%] md:left-auto md:top-[-50%] top-[-20%] transform -translate-y-1/2 z-10 md:block bg-[#F4F4F4] hover:bg-[#E11740] w-10 h-10 md:w-[3.25rem] md:h-[3.35rem] rounded-full flex items-center justify-center transition-all duration-300">
        <img
          src="/assets/prevButton.svg"
          alt="Previous"
          className="w-4 h-4 md:w-6 md:h-6 brightness-0 invert-0 transition-all duration-300 group-hover:brightness-0 group-hover:invert md:ml-[25%]"
        />
      </button>

      <button className="custom-next group absolute md:right-0 left-[18%] md:left-auto md:top-[-50%] top-[-20%] transform -translate-y-1/2 z-10 md:block bg-[#F4F4F4] hover:bg-[#E11740] w-10 h-10 md:w-[3.25rem] md:h-[3.25rem] rounded-full flex items-center justify-center transition-all duration-300">
        <img
          src="/assets/nextButton.svg"
          alt="Next"
          className="w-4 h-4 md:w-6 md:h-6 brightness-0 invert-0 transition-all duration-300 group-hover:brightness-0 group-hover:invert md:ml-[25%]"
        />
      </button>

      <Swiper
        modules={[Navigation]}
        spaceBetween={60}
        slidesPerView={slidesPerView}
        slidesPerGroup={1} // Moves exactly one slide per click
        navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }} // Custom navigation
        loop={true} // Enables infinite loop
        className="w-full"
      >
        {slidesData.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="bg-white flex gap-[1.44rem] rounded-t-2xl shadow-[0px_-25px_22.3px_-14px_rgba(113,113,113,0.10)]">
              <div className="bg-[#FFEAEE] rounded-[1.75rem]">
                <img src={slide.img} alt={slide.title1} className="w-[9rem] h-[9rem] md:w-[18.25rem] md:h-[18.25rem]" />
              </div>
              <div className="w-1/2">
                <h2 className="text-black font-[Figtree] text-[1.39081rem] md:text-[2.375rem] font-extrabold leading-[1.82288rem] md:leading-[3.625rem] tracking-[0.05563rem] md:tracking-[-0.095rem]">
                  {slide.title1}
                </h2>
                <h2 className="text-[#FF1847] font-[Figtree] text-[1.39081rem] md:text-[2.375rem] font-extrabold leading-[1.82288rem] md:leading-[3.625rem] tracking-[0.05563rem] md:tracking-[-0.095rem]">
                  {slide.title2}
                </h2>
                <p className="text-[#252525] font-[Figtree] text-[0.732rem] md:text-[1.25rem] font-normal leading-[1.24444rem] md:leading-[2.125rem] tracking-[-0.02925rem] md:tracking-[-0.05rem]">
                  {slide.description}
                </p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default TransferBenefitsScroll;
